export default __webpack_public_path__ + "static/media/checkr.8480f237.svg";